import React, { useEffect, useState } from 'react';
import 'emoji-mart/css/emoji-mart.css';
import EmojiInserterView from './EmojiInserterView';

const EmojiInserterEngine = ({
  emojiCallback,
  showEmojiDialog = () => {},
  setShowEmojiDialog = () => {},
  textInput,
  emojiTargetRef,
  ...props
}) => {

  const [alreadyClicked, setAlreadyClicked] = useState(false);

  useEffect(() => {
    if (showEmojiDialog) {
      setAlreadyClicked(false);
    }
  }, [showEmojiDialog]);

  const clickedEmoji = emoji => {
    let start, end, newTitle, textWas, whichInput;
    if (alreadyClicked || !emoji || !emoji.native) {
      return;
    }
    if (emojiTargetRef && emojiTargetRef.current) {
      whichInput = emojiTargetRef.current;
    } else {
      whichInput = textInput;
    }
    textWas = whichInput && whichInput.value ? whichInput.value : '';
    setAlreadyClicked(true);
    start = whichInput.selectionStart;
    end = whichInput.selectionEnd;
    if (start > -1) {
      newTitle = textWas.slice(0, start) + emoji.native + textWas.slice(end);
      whichInput.value = newTitle;
    }
    setShowEmojiDialog(false);
    emojiCallback(newTitle);
  };

  const viewProps = {
    clickedEmoji,
    showEmojiDialog,
    setShowEmojiDialog,
    ...props,
  };
  return <EmojiInserterView {...viewProps} />;
};

export default EmojiInserterEngine;